<template>
    <div>
        <div class="form-group">
            <label class="small">Nama</label>
            <vs-input v-model="user.name" placeholder="Nama" :loading="loading.user">
                <template #icon>
                    <box-icon name="user"></box-icon>
                </template>
            </vs-input>
        </div>
        <div class="form-group">
            <label class="small">Username</label>
            <div>
                <template v-if="loading.user">Loading...</template>
                <template v-else>{{ user.username }}</template>
            </div>
        </div>
        <div class="form-group">
            <label class="small">Email</label>
            <div>
                <template v-if="loading.user">Loading...</template>
                <template v-else>{{ user.email }}</template>
            </div>
        </div>

        <div class="mt-4">
            <vs-button block :loading="loading.user" @click="!error.user ? saveAccount() : ''">Simpan</vs-button>
        </div>
    </div>
</template>

<script>
import { usersCollection } from '@/helpers/firebase';
import accountHelper from '@/helpers/account';

export default {
    name: 'personal',
    data() {
        return {
            user: {},
            loading: {
                user: true,
            },
            error: {
                user: false,
            }
        }
    },
    methods: {
        getAccount() {
            this.loading.user = true;

            let user = accountHelper.getIdUser();
            if(user) {
                usersCollection.doc(user.email).get().then(doc => {
                    this.user = doc.data();
                    this.loading.user = false;
                }).catch(err => {
                    console.log('error get account', err);
                    this.error.user = true;
                    this.loading.user = false;
                });
            } else {
                this.loading.user = false;
                this.error.user = true;
            }
        },
        async saveAccount() {
            if(this.user.name) {
                this.loading.user = true;
                this.user.updated_at = new Date();

                await usersCollection.doc(this.user.email).update(this.user);
                accountHelper.saveToLocalStorage(this.user);

                this.$emit('resetDataAccount');

                this.loading.user = false;
            }
        }
    },
    mounted() {
        this.getAccount();
    }
}
</script>